const crashlytics = () => ({
	log: message => null,
	setUserId: userId => null,
	recordError: error => null,
})

export default crashlytics
